module.exports = __webpack_public_path__ + "img/aviatur.cedf9023.svg";